export default __webpack_public_path__ + "static/media/gallery_06.54c5ab97.jpg";